import React, { FunctionComponent } from "react";
import { useForm } from "react-hook-form";
import { Form, FormFields, FormTextField, FormNumberTextField, FormActions } from "sprint-common-web";

import { EditSeasonFormInputs } from "./EditSeasonFormInputs";
import { useEditSeasonForm } from "./useEditSeasonForm";

export interface EditSeasonFormProps {
    selectedSeasonId: string;
    onCancel(): void;
    onSubmit(updatedSeasonData: UpdatedSeasonData): void;
}

export interface UpdatedSeasonData {
    seasonId: string;
    name: string;
    number: number;
}

export const EditSeasonForm: FunctionComponent<EditSeasonFormProps> = (props: EditSeasonFormProps) => {
    const { defaultValues, editSeason, isNewSeasonNameUnique, isNewSeasonNumberUnique } = useEditSeasonForm(
        props.selectedSeasonId
    );
    const { errors, control, formState, handleSubmit } = useForm<EditSeasonFormInputs>({
        defaultValues,
        criteriaMode: "all"
    });

    const handleEditSeason = async (inputs: EditSeasonFormInputs) => {
        const updatedSeason = await editSeason(inputs);

        props.onSubmit(updatedSeason);
    };

    const handleCancelClick = () => {
        props.onCancel();
    };

    return (
        <Form onSubmit={handleSubmit(handleEditSeason)}>
            <FormFields>
                <FormTextField
                    label="Name"
                    name="name"
                    control={control}
                    errors={errors}
                    rules={{
                        required: "Please enter unique Season Name",
                        validate: isNewSeasonNameUnique
                    }}
                />
                <FormNumberTextField
                    label="Season Number"
                    name="number"
                    control={control}
                    errors={errors}
                    rules={{
                        required: "Please enter Season Number",
                        pattern: {
                            value: /^\d+$/i,
                            message: "Please enter correct Season Number"
                        },
                        validate: isNewSeasonNumberUnique
                    }}
                />
            </FormFields>
            <FormActions isLoading={formState.isSubmitting || formState.isValidating} onCancel={handleCancelClick} />
        </Form>
    );
};
